import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import $ from "jquery";
import Axios from "axios";
import url from "../../services/url";
import ClipboardJS from "clipboard/dist/clipboard";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import LoadingArea from "../../components/LoadingArea";
import FormContactsDropdown from "./FormContactsDropdown";
import { Collapse } from "antd";
import { Modal } from "antd";
import ReactLoading from "react-loading";
import CallStatusUpload from "./BulkUploadModule/CallStatusUpload";
import isConsultant from "../../services/isConsultant";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

function FormsBulkUpload() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);

  const { Panel } = Collapse;

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setBulkUploadFormId("");
  };

  const onChange = (key) => {
    console.log(key);
  };

  const [bulkUploadFormId, setBulkUploadFormId] = useState("");
  const [bulkUploadFormName, setBulkUploadFormName] = useState("");

  const handleFormId = (id, name) => {
    setBulkUploadFormId(id);
    setBulkUploadFormName(name || "");
    showModal();
  };
  const userRole = useRole();
  const [canUpload, setCanUpload] = useState(false);
  async function checkUploadPermission() {
    try {
      const allowed = await checkPermission(userRole, 'bulk_upload_module', 'upload_csv');
      setCanUpload(allowed);
    } catch (err) {
      console.error("Error checking permission:", err);
    }
  }

  useEffect(() => {
    checkUploadPermission();
  }, [userRole]);


  // Effects
  useEffect(() => {
    // new ClipboardJS(".btn-clipboard");
    fetchData();
  }, []);

  function fetchData() {
    Axios.get(url("formtemplate"), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((res) => {
        setForms(res.data);
        setTimeout(() => {
          $("#table-datatable").DataTable();
        }, 100);
        setLoading(false);
      })
      .catch(console.error);
  }

  return (
    <div>
      {!isConsultant() && <Dashboard title="Bulk Upload">
        <LoadingArea isLoading={loading}>
          <div>
            <table id="table-datatable" className="table bg-white">
              <thead>
                <tr>
                  <td className="col-md-10">Form Name</td>
                  <td className="col-md-2">
                    <div className="d-flex justify-content-center align-items-center">
                      Actions
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                {forms.map((form, k) => {
                  console.log(form.formType)
                  if (form?.formType === 'Skill_Form' || form?.formType === 'Joining_Form') {
                    return (
                      <tr key={k}>
                        <td>{form.name}</td>
                        <td>
                          <div className="d-flex justify-content-center align-items-center">
                            {canUpload && <Button
                              onClick={() => handleFormId(form._id, form.name)}
                              className="mr-1"
                              color="primary"
                              size="sm"
                            >
                              <i class="fa fa-upload" aria-hidden="true"></i> Upload
                            </Button>}
                            {/* <Button className="mr-1" color="primary" size="sm">
                          Download Sample
                        </Button> */}{" "}
                          </div>
                        </td>
                      </tr>
                    )
                  }
                })}
              </tbody>
            </table>
            <div>
              {bulkUploadFormId && (
                <Modal
                  width={1100}
                  title="Bulk Upload"
                  visible={isModalVisible}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  footer={null}
                >
                  {" "}
                  <Collapse onChange={onChange}>
                    <Panel header="Call Status Upload:-" key="1">
                      {/* <ul className="ml-4">
                      <li>
                        <p>
                          Following locations format are allowed - (amritsar,
                          kolkata, vadodara, ludhiana, bangalore, gurugram)
                        </p>
                      </li>
                      <li>
                        <p>
                          Following sources are allowed -(consultant, Walk In,
                          ERP, Digital Marketing)
                        </p>
                      </li>
                    </ul> */}
                      <CallStatusUpload />
                    </Panel>
                  </Collapse>

                  <Collapse onChange={onChange}>
                    <Panel header="Note:-" key="1">
                      <ul className="ml-4">
                        <li>
                          <p>
                            Maximum 2000 candidates will be uploaded at one time
                          </p>
                        </li>
                        <li>
                          <p>
                            Headers should match Form Field Labels (e.g., Name, Email, Phone Number, Date of Birth, Highest Qualification, Preferred Location, etc.) or standard short names (name, email, phone, source, location, current_location, date). Click "Download sample" for pre-formatted template.
                          </p>
                        </li>
                        <li>
                          <p>Date format - (DD/MM/YYYY)</p>
                        </li>
                        <li>
                          <p>
                            Following locations format are allowed - (Amritsar,
                            Kolkata, Vadodara, Ludhiana, Bangalore, Gurugram, Pune)
                          </p>
                        </li>
                        <li>
                          <p>
                            Following sources are allowed -(Consultant, Walk In, Digital Marketing, Naukri, Self Sourcing)
                          </p>
                        </li>
                        <li>
                          <p>
                            Numbers and special characters are not allowed in
                            name, source, location, current_location
                          </p>
                        </li>
                        <li>
                          <p>
                            current_location is optional (value can be blank, but column header must exist in the file)
                          </p>
                        </li>
                        <li>
                          <p>Phone number should be of 10 digits</p>
                        </li>
                      </ul>
                    </Panel>
                  </Collapse>
                  <FormContactsDropdown id={bulkUploadFormId} formName={bulkUploadFormName} />
                </Modal>
              )}
            </div>
          </div>
        </LoadingArea>
      </Dashboard>}
    </div>
  );
}

export default FormsBulkUpload;
